// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Update_container__7uJWg{
    padding-top: 10px;
    padding-bottom: 10px;
}
.Update_topRow__Rci2N{
    display: flex;
    align-items: center;
    position: relative;
}
@media(max-width: 600px){
    .Update_topRow__Rci2N{
        display: block;
        height: auto;
        margin-bottom: 0;
    }
}
.Update_borderCover__aWjFc{
    position: absolute;
    left: -30px;
    bottom: calc(100% - 20px);
    height: 100%;
    width: 5px;
    background-color: #FFFFFF;
}
@media(max-width: 600px){
    .Update_borderCover__aWjFc{
        height: 50%;
    }
}
.Update_outerCircle__ERMuS{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 15px;
    left: -35px;
    height: 18px;
    width: 18px;
    background-color: #40798C;
    border-radius: 50%;
}
.Update_innerCircle__IZL5M{
    height: 8px;
    width: 8px;
    background-color: #FFFFFF;
    border-radius: 50%;
}
.Update_title__uYJ6V{
    margin-right: 25px;
    margin-bottom: 2px;
    color: #40798C;
    font-size: 20px;
    font-family: 'Gotham Bold', serif;
}
.Update_organizer__2FBNf{
    display: flex;
    align-items: center;
    margin-left: auto;
}
.Update_organizerPicture__UoXV2{
    height: 41px;
    width: 41px;
    margin-right: 10px;
    border-radius: 50%;
    object-fit: cover;
}
.Update_organizerName__ZFpCu{
    color: #1F363D;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
    white-space: nowrap;
}
.Update_middleRow__swut-{
    display: flex;
    height: 41px;
    margin-bottom: -7px;
}
.Update_datetime__vbOxU{
    color: #1F363D;
    font-size: 14px;
    opacity: 60%;
}
@media(max-width: 600px){
    .Update_organizer__2FBNf{
        top: 0;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .Update_organizerPicture__UoXV2{
        height: 32px;
        width: 32px;
    }
    .Update_organizerName__ZFpCu{
        font-size: 14px;
    }
}
.Update_text__F5wrI{
    color: #1F363D;
    font-size: 14px;
    white-space: pre-wrap;
    overflow-x: auto;
}
.Update_pictures__bQU5\\+{
    margin-top: 10px;
}
.Update_picture__Cqm1w{
    width: calc(33.33% - 10px);
    border-radius: 10px;
    cursor: pointer;
}
.Update_picture__Cqm1w:not(:last-child){
    margin-right: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/Update.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI;QACI,cAAc;QACd,YAAY;QACZ,gBAAgB;IACpB;AACJ;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;IACnC,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;IACI;QACI,MAAM;QACN,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,WAAW;IACf;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".container{\n    padding-top: 10px;\n    padding-bottom: 10px;\n}\n.topRow{\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n@media(max-width: 600px){\n    .topRow{\n        display: block;\n        height: auto;\n        margin-bottom: 0;\n    }\n}\n.borderCover{\n    position: absolute;\n    left: -30px;\n    bottom: calc(100% - 20px);\n    height: 100%;\n    width: 5px;\n    background-color: #FFFFFF;\n}\n@media(max-width: 600px){\n    .borderCover{\n        height: 50%;\n    }\n}\n.outerCircle{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 15px;\n    left: -35px;\n    height: 18px;\n    width: 18px;\n    background-color: #40798C;\n    border-radius: 50%;\n}\n.innerCircle{\n    height: 8px;\n    width: 8px;\n    background-color: #FFFFFF;\n    border-radius: 50%;\n}\n.title{\n    margin-right: 25px;\n    margin-bottom: 2px;\n    color: #40798C;\n    font-size: 20px;\n    font-family: 'Gotham Bold', serif;\n}\n.organizer{\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n.organizerPicture{\n    height: 41px;\n    width: 41px;\n    margin-right: 10px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n.organizerName{\n    color: #1F363D;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n    white-space: nowrap;\n}\n.middleRow{\n    display: flex;\n    height: 41px;\n    margin-bottom: -7px;\n}\n.datetime{\n    color: #1F363D;\n    font-size: 14px;\n    opacity: 60%;\n}\n@media(max-width: 600px){\n    .organizer{\n        top: 0;\n        margin-top: 15px;\n        margin-bottom: 15px;\n    }\n    .organizerPicture{\n        height: 32px;\n        width: 32px;\n    }\n    .organizerName{\n        font-size: 14px;\n    }\n}\n.text{\n    color: #1F363D;\n    font-size: 14px;\n    white-space: pre-wrap;\n    overflow-x: auto;\n}\n.pictures{\n    margin-top: 10px;\n}\n.picture{\n    width: calc(33.33% - 10px);\n    border-radius: 10px;\n    cursor: pointer;\n}\n.picture:not(:last-child){\n    margin-right: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Update_container__7uJWg`,
	"topRow": `Update_topRow__Rci2N`,
	"borderCover": `Update_borderCover__aWjFc`,
	"outerCircle": `Update_outerCircle__ERMuS`,
	"innerCircle": `Update_innerCircle__IZL5M`,
	"title": `Update_title__uYJ6V`,
	"organizer": `Update_organizer__2FBNf`,
	"organizerPicture": `Update_organizerPicture__UoXV2`,
	"organizerName": `Update_organizerName__ZFpCu`,
	"middleRow": `Update_middleRow__swut-`,
	"datetime": `Update_datetime__vbOxU`,
	"text": `Update_text__F5wrI`,
	"pictures": `Update_pictures__bQU5+`,
	"picture": `Update_picture__Cqm1w`
};
export default ___CSS_LOADER_EXPORT___;
